import React, { useEffect } from "react";
import "../../../../../Assets/Styles/UserGuide.scss";

const UserProfileGuide = (props) => {
  useEffect(() => {
    if (window.innerWidth <= 450) {
      window.scrollTo(0, 0);
    } else {
      document.getElementById("user-profile-guide").scrollIntoView();
    }
  }, []);

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const toggleNextGuide = () => {
    props.ToggleNextDialog();
  };

  const togglePreviousGuide = () => {
    props.TogglePreviousDialog();
  };

  return (
    <div className="guide-dialog user-profile-guide" id="user-profile-guide">
      <i className="feather-x" onClick={() => props.CloseGuide()}></i>
      <p className="dialog-text">
        {translateText("walkthrough_homepage_user_profile")}
      </p>
      <section className="dialog-footer">
        <div className="steps-navs back" onClick={() => togglePreviousGuide()}>
          <i className="feather-arrow-left"></i>
          <p>{translateText("back")}</p>
        </div>
        <div className="indicators">
          <>
            {props.GuideHasAdditionalStep ? (
              <>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((Item, i) => (
                  <span
                    onClick={() => props.JumpToStep(i)}
                    className={
                      i === 6 ? "step-circle active-circle" : "step-circle"
                    }
                    id={"circle-" + parseInt(i)}
                  ></span>
                ))}
              </>
            ) : (
              <>
                {[1, 2, 3, 4, 5, 6, 7, 8].map((Item, i) => (
                  <span
                    onClick={() => props.JumpToStep(Item)}
                    className={
                      i === 5 ? "step-circle active-circle" : "step-circle"
                    }
                    id={"circle-" + parseInt(i + 1)}
                  ></span>
                ))}
              </>
            )}
          </>
        </div>
        <div className="steps-navs next" onClick={() => toggleNextGuide()}>
          <p>{translateText("next")}</p>
          <i className="feather-arrow-right"></i>
        </div>
      </section>
    </div>
  );
};

export default UserProfileGuide;
